export const FIND_ENRICHMENT = 'OVID/FIND_ENRICHMENT/FETCH'
export const FIND_ENRICHMENT_SUCCESS = 'OVID/FIND_ENRICHMENT/SUCCESS'
export const FIND_ENRICHMENT_FAILED = 'OVID/FIND_ENRICHMENT/FAILED'
export const FIND_ENRICHMENT_NOT_FOUND = 'OVID/FIND_ENRICHMENT/NOT_FOUND'
